<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab">
      <a (click)="activeTab = tab.id" style="cursor: pointer;" class="btn-sm">
        {{ tab.name }}
      </a>
    </li>
}
  </ul>

  <div class="tab-content">
    <!-- Diagnostic Tab -->
    @if (activeTab === 1) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      @if (showDiagLoader) {
<div class="viewFormLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}

      <!-- Two column layout: Forms + Accounts -->
      @if (formData.length > 0 && accountData.length > 0) {
<div class="PC_SCHD_A_Diag">
        <div class="diag-columns">
          <!-- Left Column: Forms -->
          <div class="diag-column-left">
            <div class="slim-scroll-block">
              <table class="main_table custom-table">
                <thead>
                  <tr>
                    <th colspan="3">
                      <span class="schd-name">Forms</span>
                    </th>
                    <th colspan="3">
                      <div class="legend_block">
                        <span class="legend_mul"></span>
                        <span>Multiplier</span>
                        <span class="legend_amt"></span>
                        <span>Amount</span>
                      </div>
                    </th>
                  </tr>
                  <tr>
                    <th colspan="1" style="text-align: center;width: 42px;">
                      <span>#</span>
                    </th>
                    <th colspan="3">
                      <span>Forms Description</span>
                    </th>
                    <th colspan="2" class="subHeader">
                      <span>Amount</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- 1st Level Drilldown -->
                  @for (row of formData; track $index; let i = $index) {
<tr>
                    <td colspan="1" style="vertical-align: top;">{{row.LINE_NO}}</td>
                    <td colspan="3">
                      <span style="cursor: pointer;" (click)="getAccts('main', row.toggleTotal, 0, row.ACCT, i, row.LINE_NO)">
                        @if (!row.toggleTotal) {
<span><i class="fa fa-plus-circle"></i></span>
}
                        @if (row.toggleTotal) {
<span><i class="fa fa-minus-circle"></i></span>
}
                      </span> &nbsp; {{row.DESCRIPTION}}

                      <!-- 2nd Level Drilldown -->
                      @if (row.toggleTotal) {
<div class="totalLines">
                        @if (row.main_loader) {
<div class="viewFormLoader">
                          <i class="fa fa-spinner fa-spin gt-refresh"></i>
                        </div>
}
                        <table class="custom-table">
                          @for (total of totalLines; track $index; let j = $index) {
<tr>
                            <td style="vertical-align: top;">{{total.LINE_NO}}</td>
                            <td>
                              <div style="display: flex;">
                                <span style="cursor: pointer;" (click)="getAccts('main_sub', total.toggle, 0, total.ACCT, j, total.LINE_NO)">
                                  @if (!total.toggle && show_toggle_total) {
<span><i class="fa fa-plus-circle"></i></span>
}
                                  @if (total.toggle && show_toggle_total) {
<span><i class="fa fa-minus-circle"></i></span>
}
                                </span>&nbsp;
                                <span>{{total.DESCRIPTION}}</span>
                              </div>

                              <!-- 3rd Level Drilldown -->
                              @if (total.toggle) {
<div class="childAcctBlock">
                                @if (total.main_sub_loader) {
<div class="viewFormLoader">
                                  <i class="fa fa-spinner fa-spin gt-refresh"></i>
                                </div>
}
                                <table class="custom-table">
                                  @for (lines of main_sub_data; track $index; let k = $index) {
<tr>
                                    <td style="vertical-align: top;">{{lines.LINE_NO}}</td>
                                    <td>
                                      <span style="cursor: pointer;" (click)="getAccts('accounts', lines.toggle, 0, lines.ACCT, k, lines.LINE_NO)">
                                        @if (!lines.toggle && show_toggle) {
<span><i class="fa fa-plus-circle"></i></span>
}
                                        @if (lines.toggle && show_toggle) {
<span><i class="fa fa-minus-circle"></i></span>
}
                                      </span>&nbsp;<span>{{lines.DESCRIPTION}}</span>

                                      <!-- 4th Level Drilldown -->
                                      @if (lines.toggle) {
<div class="childAcctBlock" style="background: lightyellow;">
                                        @if (lines.child_loader) {
<div class="viewFormLoader">
                                          <i class="fa fa-spinner fa-spin gt-refresh"></i>
                                        </div>
}
                                        <table class="custom-table">
                                          @for (acct of acct_data; track $index) {
<tr>
                                            <td style="vertical-align: top;">{{acct.LINE_NO}}</td>
                                            <td><span>{{acct.DESCRIPTION}}</span></td>
                                            <td><span style="background: gray;" class="amountBadge">{{acct.MULTIPLIER}}</span></td>
                                            <td><span class="amountBadge">{{acct.AMOUNT}}</span></td>
                                          </tr>
}
                                        </table>
                                      </div>
}
                                    </td>
                                    <td style="vertical-align: top;"><span style="background: gray;" class="amountBadge">{{lines.MULTIPLIER}}</span></td>
                                    <td style="vertical-align: top;"><span class="amountBadge">{{lines.AMOUNT}}</span></td>
                                  </tr>
}
                                </table>

                                @if (no_main_sub_data) {
<div class="no_records">No Mappings Found</div>
}
                              </div>
}
                            </td>
                            <td style="text-align: right;vertical-align: top;">
                              <span style="background: gray;" class="amountBadge">{{total.MULTIPLIER}}</span>
                            </td>
                            <td style="text-align: right;vertical-align: top;">
                              <span class="amountBadge">{{total.AMOUNT}}</span>
                            </td>
                          </tr>
}
                        </table>
                        @if (no_total_lines) {
<div class="no_records">No Mappings Found</div>
}
                      </div>
}
                    </td>
                    <td colspan="2" style="text-align: right;vertical-align: top;">
                      <span class="amountBadge">{{row.AMOUNT}}</span>
                    </td>
                  </tr>
}
                </tbody>
              </table>
            </div>
          </div>

          <!-- Right Column: Accounts -->
          <div class="diag-column-right">
            <div class="slim-scroll-block">
              <table class="main_table custom-table">
                <thead>
                  <tr>
                    <th colspan="4">
                      <span class="schd-name">Accounts</span>
                    </th>
                    <th colspan="4">
                    </th>
                  </tr>
                  <tr>
                    <th colspan="1" style="text-align: left;width: 64px;">
                      <span>#</span>
                    </th>
                    <th colspan="6">
                      <span>Accounts Description</span>
                    </th>
                    <th colspan="1" class="subHeader">
                      <span>Amount</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  @for (row of accountData; track $index; let i = $index) {
<tr>
                    <td colspan="1" style="text-align: left;width: 64px;vertical-align: top;">{{i+1}}</td>
                    <td colspan="6">
                      <span style="cursor: pointer;" (click)="getAccts('main_acct', row.toggle, 0, row.ACCT, i, row.LINE_NO)">
                        @if (!row.toggle) {
<span><i class="fa fa-plus-circle"></i></span>
}
                        @if (row.toggle) {
<span><i class="fa fa-minus-circle"></i></span>
}
                      </span> &nbsp; {{row.DESCRIPTION}}

                      <!-- 1st level drilldown (main_acct) -->
                      @if (row.toggle) {
<div class="totalLines">
                        @if (row.main_loader) {
<div class="viewFormLoader">
                          <i class="fa fa-spinner fa-spin gt-refresh"></i>
                        </div>
}
                        <table class="custom-table">
                          @for (total of acctChild; track $index) {
<tr>
                            <td style="vertical-align: top;">{{total.LINE_NO}}</td>
                            <td>
                              <span style="cursor: pointer;">
                                &nbsp;<span>{{total.DESCRIPTION}}</span>
                              </span>
                            </td>
                          </tr>
}
                        </table>
                        @if (no_acct_child) {
<div class="no_records">No Mappings Found</div>
}
                      </div>
}
                    </td>
                    <td colspan="1" style="text-align: right;vertical-align: top;"><span class="amountBadge">{{row.AMOUNT}}</span></td>
                  </tr>
}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
}

      <!-- Full width layout: Forms only -->
      @if (formData.length > 0 && accountData.length == 0) {
<div class="PC_SCHD_A_Diag">
        <div class="diag-blocks">
          <div class="slim-scroll-block">
            <table class="main_table custom-table">
              <thead>
                <tr>
                  <th colspan="3">
                    <span class="schd-name">Forms</span>
                  </th>
                  <th colspan="3">
                    <div class="legend_block">
                      <span class="legend_mul"></span>
                      <span>Multiplier</span>
                      <span class="legend_amt"></span>
                      <span>Amount</span>
                    </div>
                  </th>
                </tr>
                <tr>
                  <th colspan="1" style="text-align: center;width: 42px;">
                    <span>#</span>
                  </th>
                  <th colspan="3">
                    <span>Forms Description</span>
                  </th>
                  <th colspan="2" class="subHeader">
                    <span>Amount</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <!-- 1st Level Drilldown (parent) -->
                @for (row of formData; track $index; let i = $index) {
<tr>
                  <td colspan="1" style="vertical-align: top;">{{row.LINE_NO}}</td>
                  <td colspan="3">
                    <span style="cursor: pointer;" (click)="getAccts('main', row.toggleTotal, 0, row.ACCT, i, row.LINE_NO)">
                      @if (!row.toggleTotal) {
<span><i class="fa fa-plus-circle"></i></span>
}
                      @if (row.toggleTotal) {
<span><i class="fa fa-minus-circle"></i></span>
}
                    </span> &nbsp; {{row.DESCRIPTION}}

                    <!-- 2nd Level Drilldown (main) -->
                    @if (row.toggleTotal) {
<div class="totalLines">
                      @if (row.main_loader) {
<div class="viewFormLoader">
                        <i class="fa fa-spinner fa-spin gt-refresh"></i>
                      </div>
}
                      <table class="custom-table">
                        @for (total of totalLines; track $index; let j = $index) {
<tr>
                          <td style="vertical-align: top;">{{total.LINE_NO}}</td>
                          <td>
                            <span style="cursor: pointer;" (click)="getAccts('main_sub', total.toggle, 0, total.ACCT, j, total.LINE_NO)">
                              @if (!total.toggle && show_toggle_total) {
<span><i class="fa fa-plus-circle"></i></span>
}
                              @if (total.toggle && show_toggle_total) {
<span><i class="fa fa-minus-circle"></i></span>
}
                            </span>&nbsp;<span>{{total.DESCRIPTION}}</span>

                            <!-- 3rd Level Drilldown (main_sub_data) -->
                            @if (total.toggle) {
<div class="childAcctBlock">
                              @if (total.main_sub_loader) {
<div class="viewFormLoader">
                                <i class="fa fa-spinner fa-spin gt-refresh"></i>
                              </div>
}
                              <table class="custom-table">
                                @for (lines of main_sub_data; track $index; let k = $index) {
<tr>
                                  <td style="vertical-align: top;">{{lines.LINE_NO}}</td>
                                  <td>
                                    <span style="cursor: pointer;" (click)="getAccts('accounts', lines.toggle, 0, lines.ACCT, k, lines.LINE_NO)">
                                      @if (!lines.toggle && show_toggle) {
<span><i class="fa fa-plus-circle"></i></span>
}
                                      @if (lines.toggle && show_toggle) {
<span><i class="fa fa-minus-circle"></i></span>
}
                                    </span>&nbsp;<span>{{lines.DESCRIPTION}}</span>

                                    <!-- 4th Level Drilldown (accounts) -->
                                    @if (lines.toggle) {
<div class="childAcctBlock" style="background: lightyellow;">
                                      @if (lines.child_loader) {
<div class="viewFormLoader">
                                        <i class="fa fa-spinner fa-spin gt-refresh"></i>
                                      </div>
}
                                      <table class="custom-table">
                                        @for (acct of acct_data; track $index) {
<tr>
                                          <td style="vertical-align: top;">{{acct.LINE_NO}}</td>
                                          <td><span>{{acct.DESCRIPTION}}</span></td>
                                          <td><span style="background: gray;" class="amountBadge">{{acct.MULTIPLIER}}</span></td>
                                          <td><span class="amountBadge">{{acct.AMOUNT}}</span></td>
                                        </tr>
}
                                      </table>
                                    </div>
}
                                  </td>
                                  <td style="vertical-align: top;"><span style="background: gray;" class="amountBadge">{{lines.MULTIPLIER}}</span></td>
                                  <td style="vertical-align: top;"><span class="amountBadge">{{lines.AMOUNT}}</span></td>
                                </tr>
}
                              </table>

                              @if (no_main_sub_data) {
<div class="no_records">No Mappings Found</div>
}
                            </div>
}
                          </td>
                          <td style="text-align: right;vertical-align: top;">
                            <span style="background: gray;" class="amountBadge">{{total.MULTIPLIER}}</span>
                          </td>
                          <td style="text-align: right;vertical-align: top;">
                            <span class="amountBadge">{{total.AMOUNT}}</span>
                          </td>
                        </tr>
}
                      </table>
                      @if (no_total_lines) {
<div class="no_records">No Mappings Found</div>
}
                    </div>
}
                  </td>
                  <td colspan="2" style="text-align: right;vertical-align: top;">
                    <span class="amountBadge">{{row.AMOUNT}}</span>
                  </td>
                </tr>
}
              </tbody>
            </table>
          </div>
        </div>
      </div>
}

      <!-- Full width layout: Accounts only -->
      @if (formData.length == 0 && accountData.length > 0) {
<div class="PC_SCHD_A_Diag">
        <div class="diag-blocks">
          <div class="slim-scroll-block">
            <table class="custom-table">
              <thead>
                <tr>
                  <th colspan="4">
                    <span class="schd-name">Accounts</span>
                  </th>
                  <th colspan="4">
                  </th>
                </tr>
                <tr>
                  <th colspan="1" style="text-align: left;width: 64px;">
                    <span>#</span>
                  </th>
                  <th colspan="6">
                    <span>Accounts Description</span>
                  </th>
                  <th colspan="1" class="subHeader">
                    <span>Amount</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (row of accountData; track $index; let i = $index) {
<tr>
                  @if (row.TYPE == 'tb-account') {
<td colspan="1" style="text-align: left;width: 64px;vertical-align: top;">{{i+1}}</td>
}
                  @if (row.TYPE == 'tb-account') {
<td colspan="6">
                    <span style="cursor: pointer;" (click)="row.toggle = !row.toggle">
                      @if (!row.toggle) {
<span><i class="fa fa-plus-circle"></i></span>
}
                      @if (row.toggle) {
<span><i class="fa fa-minus-circle"></i></span>
}
                    </span> &nbsp; {{row.DESCRIPTION}}
                    @if (row.toggle) {
<div class="childAcctBlock">
                      <ol>
                        @for (child of row.childAcct; track $index) {
<li style="padding: 5px 26px;">{{child.DESCRIPTION}}
                          <span class="amountBadge">{{child.AMOUNT}}</span>
                        </li>
}
                      </ol>
                      @if (!row.childAcct) {
<div class="no_records">No Records Found</div>
}
                    </div>
}
                  </td>
}
                  <td colspan="1" style="text-align: right;vertical-align: top;"><span class="amountBadge">{{row.AMOUNT}}</span></td>
                </tr>
}
              </tbody>
            </table>
          </div>
        </div>
      </div>
}

      <!-- No data message -->
      @if (!showDiagLoader && formData.length == 0 && accountData.length == 0) {
<div class="PC_SCHD_A_Diag">
        <div class="diag-blocks">
          <div class="block" style="height:50px;">
            <table class="custom-table">
              <thead>
                <tr>
                  <th colspan="12"><span>Whitepaper info unavailable.</span></th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
}
    </div>
}

    <!-- Form View Tab -->
    @if (activeTab === 2) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      @if (showFormLoader) {
<div class="viewFormLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}

      <div class="L_SCHD_A">
        @if (scheduleAFormView.rows.length > 0) {
<table class="custom-table">
          <thead>
            <tr>
              <th colspan="5">
                <span class="schd-name">Schedule A</span>
                <span class="schd-desc">Schedule A Dividends, Inclusions, Dividends-Recieved Deduction, and Other Special Deductions</span>
                <span class="schd-ins">(see instructions)</span>
              </th>
            </tr>
            <tr>
              <th colspan="2" class="subDescriptionHeader">
                <span class='proration_span'>Dividends subject to proration</span>
              </th>
              <th colspan="1" class="subHeader subHeader-centered">
                <span class="schd-sub">
                  (a) Dividends and inclusions
                </span>
              </th>
              <th colspan="1" class="subHeader subHeader-centered" style="width: 69px;">
                <span class="schd-sub">
                  (b) %
                </span>
              </th>
              <th colspan="1" class="subHeader subHeader-centered">
                <span class="schd-sub">
                  (c) Deductions (a) times (b)
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (row of scheduleAFormView.rows; track $index) {
<tr>
              <td>{{row.num}}</td>
              <td class="subDescriptionHeader">
                {{row.description}}
              </td>
              <td class="">
                <div class="input_enabled">
                  {{numberWithCommas(row.value1)}}
                </div>
              </td>
              <td class="">
                <div class="percentage_col">
                  {{row.percent}}
                </div>
              </td>
              <td class="">
                <div class="input_enabled">
                  {{numberWithCommas(row.value2)}}
                </div>
              </td>
            </tr>
}
          </tbody>
        </table>
}
      </div>
    </div>
}
  </div>
</div>

<!-- STANDARD Footer (No save button as this is view-only component) -->
<div class="modal-footer" [hidden]="minimise">
  <button class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
</div>

